export default __webpack_public_path__ + "static/media/FinanceComparison.32ce20bc.webm";